import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-success-screen',
  templateUrl: './success-screen.component.html',
  styleUrls: ['./success-screen.component.scss'],
  standalone: false
})
export class SuccessScreenComponent {

  @Input() icon: string = 'fa-circle-check';
  @Input() color: 'success' | 'error' = 'success';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() messageAction: string = '';
  @Input() buttonText: string = '';
  @Input() buttonLoading: boolean = false;
  @Output() buttonClicked: EventEmitter<any> = new EventEmitter();

  constructor() {}

  handleButtonClick() {
    this.buttonClicked.emit();
  }
}
